import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import BreadcrumbSeparator from "../BreadcrumbSeparator";
import styles from "./BreadcrumbItem.module.scss";

const BreadcrumbItem = ({ isLast, children, type, className, ...rest }) => {
  const separator = type === "link" ? ">" : "-";

  return (
    <>
      <li className={cx(styles.breadcrumbItem, styles[type], className)} {...rest}>
        {children}
      </li>
      {isLast && <BreadcrumbSeparator>{separator}</BreadcrumbSeparator>}
    </>
  );
};
BreadcrumbItem.defaultProps = {
  type: undefined,
  isLast: false,
  className: undefined
};

BreadcrumbItem.propTypes = {
  /** if true will not draw separator */
  isLast: PropTypes.bool,
  /** Defines item style (link | section | subSection) and separator type (> | -) */
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};
export default BreadcrumbItem;
